// Provider component that supplies presence state and helpers to the component tree via PresenceContext
import type { ReactNode } from "react";
import { useHouseholdRealtime } from "../hooks/useHouseholdRealtime";
import { PresenceContext } from "../hooks/usePresenceContext";

export function PresenceProvider({ children }: { children: ReactNode }) {
  const presenceData = useHouseholdRealtime();

  return (
    <PresenceContext.Provider value={presenceData}>
      {children}
    </PresenceContext.Provider>
  );
}
